module.exports = __webpack_public_path__ + "img/heromenu.8aefaa88.svg";